import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ErrorException from "src/components/ErrorException";
import { ApiGatewayUrl } from "../../src/appsettings";
import Rest from "../../src/core/rest";
export const getRecordingsByUser = createAsyncThunk(
    "recording/getRecordingsByUser",
    async () => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/userrecordings");
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const AutoStopAllRecording = createAsyncThunk(
    "userRecording/autoStopAllRecording",
    async () => {
        try {
            const respond = await Rest.put(ApiGatewayUrl + "/userrecordings");
            return respond.data;
        } catch (ex) {
            ErrorException(ex.response);
        }
    }
)

export const userRecordingSlice = createSlice({
    name: 'userRecording',
    initialState: {
        data: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(AutoStopAllRecording.fulfilled, (state, action) => {
                return { ...state, data: action.payload }
            })
    }
})

export const userRecordingActions = userRecordingSlice.actions;
export const logoutState = (state) => state.userRecording;
export default userRecordingSlice.reducer;